export default {
    methods: {
        isProd(env) {
            return env === 'production';
        }
    }
};
